// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { getMessaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCyx3cG2J3XzN6vnJ69cCXJ00XgrTlUFh0",
  authDomain: "wallof-standing.firebaseapp.com",
  projectId: "wallof-standing",
  storageBucket: "wallof-standing.firebasestorage.app",
  messagingSenderId: "265242795058",
  appId: "1:265242795058:web:c94bd9321daec1b7b8302b",
  measurementId: "G-DCH7CJNM0F",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const cFunctions = getFunctions(app);
const firestore = getFirestore(app);
const fMessaging = getMessaging(app);

export { app, cFunctions, firestore, fMessaging, analytics };
